const env = {};
env.hosts = [
  {
    api_url: 'https://ivc-api-develop.mindsetmedical.com',
    ui_urls: [
      {
        url: 'https://ivc-app-develop.mindsetmedical.com',
        type: 'VITAL-CORE',
      },
    ],
  },
  {
    api_url: 'https://api-develop.mindsetmedical.com',
    ui_urls: [
      {
        url: 'https://vital-trac-develop.mindsetmedical.com',
        type: 'VITAL-TRAC',
      },
    ],
  },
  {
    api_url: 'https://ivc-rr-api-develop.mindsetmedical.com',
    ui_urls: [
      {
        url: 'https://ivc-rr-app-develop.mindsetmedical.com',
        type: 'VITAL-CORE-RR',
      },
    ],
  },
  {
    api_url: 'https://ivc-api-staging.mindsetmedical.com',
    ui_urls: [
      {
        url: 'https://ivc-app-staging.mindsetmedical.com',
        type: 'VITAL-CORE',
      },
    ],
  },
  {
    api_url: 'https://api-staging.mindsetmedical.com',
    ui_urls: [
      {
        url: 'https://vital-trac-staging.mindsetmedical.com',
        type: 'VITAL-TRAC',
      },
    ],
  },
  {
    api_url: 'https://ivc-rr-api-staging.mindsetmedical.com',
    ui_urls: [
      {
        url: 'https://ivc-rr-app-staging.mindsetmedical.com',
        type: 'VITAL-CORE-RR',
      },
    ],
  },
  {
    api_url: 'https://ivc-api.mindsetmedical.com',
    ui_urls: [
      {
        url: 'https://ivc-app.mindsetmedical.com',
        type: 'VITAL-CORE',
      },
    ],
  },
  {
    api_url: 'https://api.mindsetmedical.com',
    ui_urls: [
      {
        url: 'https://vital-trac.mindsetmedical.com',
        type: 'VITAL-TRAC',
      },
    ],
  },
  {
    api_url: 'https://ivc-rr-api.mindsetmedical.com',
    ui_urls: [
      {
        url: 'https://ivc-rr-app.mindsetmedical.com',
        type: 'VITAL-CORE-RR',
      },
    ],
  },
  {
    api_url: 'http://localhost:3001',
    ui_urls: [
      {
        url: 'http://localhost:3011',
        type: 'VITAL-CORE',
      },
      {
        url: 'http://localhost:3012',
        type: 'VITAL-CORE-RR',
      },
      {
        url: 'http://localhost:3013',
        type: 'VITAL-TRAC',
      },
    ],
  },
];

env.DEFAULT_API_URL = 'https://ivc-api-develop.mindsetmedical.com';
env.DEFAULT_PRO_URL = 'https://ivc-app-develop.mindsetmedical.com';
env.DEFAULT_PRO_TYPE = 'VITAL-CORE';

export default env;
